// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.84.1-next',
  revision: '01da1b14d',
  branch: 'next',
  date: 'Wed, 28 Jan 2026 15:30:27 GMT'
};